import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useRef, useState } from "react";

const images = [
    "/img/profile_2.jpg",
    "/img/profile_3.jpg",
    "/img/profile_1.jpg",
];

export default function ImageSlider() {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % images.length);
        }, 6000);

        return () => clearInterval(interval);
    }, []);

    // click để next
    const handleClick = () => {
        setIndex((prev) => (prev + 1) % images.length);
    };

    return (
        <div
            className="relative aspect-square rounded-xl overflow-hidden border"
            onClick={handleClick}
        >
            <AnimatePresence mode="wait">
                <motion.img
                    key={images[index]}
                    src={images[index]}
                    className="absolute inset-0 w-full h-full object-cover"
                    initial={{ opacity: 0, scale: 1.05 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    transition={{ duration: 0.6, ease: "easeInOut" }}
                />
            </AnimatePresence>
        </div>
    );
}